import React from 'react';
import Purchase from 'billing/purchases/Purchase';
import PayPurchase from 'billing/purchases/PayPurchase';
import Autopay from 'account/Autopay';

import styles from './index.module.css';
import cart_icon from './cart_icon.svg';

const UnpaidPurchase = ({ id }) => {
  return (
    <div className="UnpaidPurchase">
      <h1>
        Checkout
        <img className={styles.headerImg} src={cart_icon} alt="" />
      </h1>
      <Purchase id={id} />
      <PayPurchase id={id} />
      <h2>Autopay</h2>
      <Autopay />
    </div>
  );
}

export default UnpaidPurchase;
